import React from 'react';
import Flickity from 'react-flickity-component';
import "flickity/dist/flickity.css";
import './stacks.css'
import { TrainingSliderCard } from '../card';

export const Slider = ({ cards }) => {
  const flickityOptions = {
    pageDots: false,
    wrapAround: true,
  }
  return (
    <Flickity
      className='carousel w-11/12 md:w-4/5 m-auto'
      elementType='div'
      options={flickityOptions}
      reloadOnUpdate
    >
      {cards.map((card) => {
        return <div className="carousel-cell" key={card.node.id}>
          <div className="width sm:w-80 lg:w-96 xl:w-100 h-60 bg-primary rounded-lg slider">
            <TrainingSliderCard {...card.node} />
          </div>
        </div>

      })}
    </Flickity>
  )
}